import React from 'react';
import Styled from './styles';

import GeneratePaymentLink from './GeneratePaymentLink';
import GenerateUpgradePaymentLink from './GenerateUpgradePaymentLink';
import GetCompanyId from './GetCompanyId';
import ExtendPaymentLink from './ExtendPaymentLink';
import CheckKycStatus from './CheckKycStatus';
import GetCompanyPitch from './GetCompanyPitch';
import GetMoreLeads from './GetMoreLeads';
import GenerateEmandateLink from './GenerateEmandateLink';
import CatalogueSearch from './CatalogueSearch';
import CreateChargebeeCustomer from './CreateChargebeeCustomer';
import RazorpaySmartCollect from './RazorpaySmartCollect';
import api from '../../lib/api';

const data = [
  {
    value: 'Create payment link ',
    field: 'create_payment_link'
  },
  {
    value: 'Create upgrade payment link ',
    field: 'create_upgrade_payment_link'
  },
  {
    value: 'Get company Id ',
    field: 'get_company_id'
  },
  {
    value: 'Update payment link',
    field: 'extend_payment_link'
  },
  {
    value: 'Check KYC Status',
    field: 'check_kyc_status'
  },
  {
    value: 'Get Sales Pitch',
    field: 'get_sales_pitch'
  },
  {
    value: 'Get More Leads',
    field: 'get_more_leads'
  },
  {
    value: 'Create e-mandate link ',
    field: 'create_emandate_link'
  },
  {
    value: 'Search catalogue ',
    field: 'search_catalogue'
  },
  {
    value: 'Create chargebee customer ',
    field: 'create_chargebee_customer'
  },
  {
    value: 'DoubleTick Enterprise Plan',
    field: 'razorpay_smart_collect'
  },
  {
    value: 'Generate quotation',
    field: 'generate_quotation'
  },
  {
    value: 'Upsell Addons',
    field: 'upsell_addons'
  }
];
class SalesUtility extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedTab: 'get_company_id'
    };
  }

  getTab = type => {
    switch (type) {
      case 'create_payment_link':
        return <GeneratePaymentLink />;
      case 'create_upgrade_payment_link':
        return <GenerateUpgradePaymentLink />;
      case 'get_company_id':
        return <GetCompanyId />;
      case 'extend_payment_link':
        return <ExtendPaymentLink />;
      case 'check_kyc_status':
        return <CheckKycStatus />;
      case 'get_sales_pitch':
        return <GetCompanyPitch />;
      case 'get_more_leads':
        return <GetMoreLeads />;
      case 'create_emandate_link':
        return <GenerateEmandateLink />;
      case 'search_catalogue':
        return <CatalogueSearch />;
      case 'create_chargebee_customer':
        return <CreateChargebeeCustomer />;
      case 'razorpay_smart_collect':
        return <RazorpaySmartCollect />;
      case 'generate_quotation':
      case 'upsell_addons':
      default:
        return null;
    }
  };

  redirectHandler = async type => {
    const {
      redirectUrl
    } = await api.getQuotationRedirectUrl(type);
    window.open(redirectUrl, '_blank');
  }

  render() {
    const { selectedTab } = this.state;
    return (
      <Styled.SalesUtilityContainer>
        <Styled.NavBarContainer>
          <Styled.NavBar>Quicksell Sales Utility</Styled.NavBar>
        </Styled.NavBarContainer>
        <Styled.PaymentAndGenerateLinkContainer>
          <Styled.LeftContainer>
            <Styled.LeftContent>
              {data.map(tab => {
                return (
                  <Styled.MappedContent
                    key={tab.field}
                    onClick={async () => {
                      if (tab.field === 'generate_quotation' || tab.field === 'upsell_addons') {
                        await this.redirectHandler(tab.field)
                      } else {
                        this.setState({ selectedTab: tab.field });
                      }
                    }}
                  >
                    <Styled.ContentTitle isSelected={selectedTab === tab.field}>
                      {tab.value}
                    </Styled.ContentTitle>
                  </Styled.MappedContent>
                );
              })}
            </Styled.LeftContent>
          </Styled.LeftContainer>
          <Styled.RightContainer>
            {this.getTab(this.state.selectedTab)}
          </Styled.RightContainer>
        </Styled.PaymentAndGenerateLinkContainer>
      </Styled.SalesUtilityContainer>
    );
  }
}

export default SalesUtility;



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/index.js